import React from 'react'
import { IconProps } from '../../types/types'

const IconLogOut:React.FC<IconProps> = ({ size = '20', color = '#00214E' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.4165 6.29965C7.67484 3.29965 9.2165 2.07465 12.5915 2.07465H12.6998C16.4248 2.07465 17.9165 3.56631 17.9165 7.29131V12.7246C17.9165 16.4496 16.4248 17.9413 12.6998 17.9413H12.5915C9.2415 17.9413 7.69984 16.733 7.42484 13.783" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.5001 10H3.01672" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.87504 7.20831L2.08337 9.99998L4.87504 12.7916" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconLogOut